import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { Box, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import type { PassType } from "../models/PassType";
import { activeColumnDef } from "@/controls/ag-grid/components/ActiveColumn";

interface UseTableDataProps {
	onDelete: (passType: PassType) => void;
}

export const useTableData = ({ onDelete }: UseTableDataProps) => {
	const columnDefs: ColDef<PassType>[] = [
		{
			field: "Name",
			headerName: "Name",
			flex: 1,
			sortable: true,
			filter: true,
		},
		{
			field: "Description",
			headerName: "Description",
			flex: 2,
		},
		activeColumnDef<PassType>(),
		{
			headerName: "",
			width: 60,
			minWidth: 60,
			maxWidth: 60,
			sortable: false,
			filter: false,
			resizable: false,
			suppressSizeToFit: true,
			cellRenderer: (params: ICellRendererParams<PassType>) => {
				if (!params.data) return null;
				return (
					<Box
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							height: "100%",
						}}
					>
						<Tooltip title="Delete">
							<IconButton
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									onDelete(params.data as PassType);
								}}
								color="error"
							>
								<DeleteIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					</Box>
				);
			},
		},
	];

	return { columnDefs };
};
